import {LoadingSpinner} from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import AddPatient from './addPatient'
import SelectProduct from './selectProduct'
import {useState} from 'react'
import './appointment.css'
import TimeSlotModal from './timeSlot'
import ConfirmAppointment from './confirmAppoinmnetCom'
import {PatientInfoType} from './types/patientDataType'
import {DownloadPdfModal} from '../modals/downloadPdfModel'
import {useLocation} from 'react-router-dom'

const CreateAppointment = (props: any) => {
  const location = useLocation()


  const consumerApptData: any = location?.state

  console.log(consumerApptData?.isConsumerAppt ? 2 : 1)
  const [step, setStep] = useState(consumerApptData?.isConsumerAppt ? 2 : 1)
  const [selectedTests, setSelectedTests] = useState<any[]>([])
  const [dateTime, setDateTime] = useState<any>(
    consumerApptData?.isConsumerAppt ? consumerApptData.dateTime : ''
  )

  const [patientInfo, setPatientInfo] = useState<PatientInfoType>(
    consumerApptData?.isConsumerAppt
      ? consumerApptData.patientInfo
      : {
          patientName: '',
          patientGender: '',
          patientId: '',
          patientNumber: '',
          doctorName: '',
          doctorNumber: '',
          doctorId: '',
          specialty: '',
        }
  )

  const [product, setProduct] = useState('')
  const [showTimeSlotModal, setShowTimeSlotModal] = useState(false)
  const [confirmData, setConfirmData] = useState<any>(null)
  const [showDownloadModal, setShowDownloadModal] = useState(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const handleStep = (step: number) => {
    setStep(step)
  }

  const againSeledtSlot = () => {
    console.log('Again select slot called')
    console.log("Current dateTime state:", dateTime)
    setShowTimeSlotModal(true)
  }


  const handleTestSelect = (test: any) => {
    console.log('test selected :', test)
    setSelectedTests((prev) => {
      // Toggle selection
      if (prev.some((t) => t.id === test.id)) {
        return prev.filter((t) => t.id !== test.id)
      } else {
        return [...prev, test]
      }
    })
  }

  const handleRemoveTest = (testId: string) => {
    setSelectedTests((prev) => prev.filter((t) => t.id !== testId))
  }

  const handleRemoveGroup = (groupName: string) => {
    setSelectedTests((prev) => prev.filter((t) => (t.groupName || 'Other') !== groupName))
  }

  const closeModal = () => {
    setShowTimeSlotModal(false)
    setDateTime('')
  }

  const handlePatientInfo = (info: any) => {
    setPatientInfo(info)
  }

  return (
    <div>
      {step === 1 && <AddPatient handleStep={handleStep} onPatientInfo={handlePatientInfo} />}
      {step === 2 && (
        <>
          <SelectProduct
            onTestSelect={handleTestSelect}
            selectedTests={selectedTests}
            setProduct={setProduct}
          />
          {selectedTests.length > 0 && (
            <div className='mt-3' style={{}}>
              <strong>Selected Tests:</strong>
              <div className='d-flex flex-column gap-3 mt-2' style={{overflowX: 'auto'}}>
                {(
                  Object.entries(
                    selectedTests.reduce((groups: any, test: any) => {
                      const group = test.groupName || 'Other'
                      if (!groups[group]) groups[group] = []
                      groups[group].push(test)
                      return groups
                    }, {})
                  ) as [string, any[]][]
                ).map(([groupName, tests]) => {
                  const groupTotal = tests.reduce((sum, t) => sum + (t.testCost || 0), 0)

                  return (
                    <div
                      key={groupName}
                      className='p-3 border rounded bg-white shadow position-relative'
                      style={{
                        minWidth: 280,
                        marginRight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <div
                        className='fw-bold mb-2 d-flex align-items-center'
                        style={{color: '#0d6efd', width: '100%', justifyContent: 'space-between'}}
                      >
                        <span>{groupName}</span>
                        <span
                          style={{
                            cursor: 'pointer',
                            color: '#dc3545',
                            fontSize: '1.2em',
                            marginLeft: 8,
                          }}
                          title='Remove all tests in this group'
                          onClick={() => handleRemoveGroup(groupName)}
                        >
                          ✕
                        </span>
                      </div>
                      <div className='d-flex flex-row flex-wrap gap-2 mb-2' style={{width: '100%'}}>
                        {tests.map((test) => (
                          <div
                            key={test.id}
                            className='d-flex align-items-center border rounded px-2 py-1 position-relative'
                            style={{background: '#f8f9fa', minWidth: 120}}
                          >
                            <span>{test.testName}</span>
                            <span className='ms-2 text-muted'>₹{test.testCost}</span>
                            <span
                              style={{
                                cursor: 'pointer',
                                color: '#dc3545',
                                marginLeft: 8,
                                fontWeight: 'bold',
                              }}
                              title='Remove this test'
                              onClick={() => handleRemoveTest(test.id)}
                            >
                              ✕
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className='mt-2 fw-bold text-end w-100'>Total: ₹{groupTotal}</div>
                    </div>
                  )
                })}
              </div>
              {/* Overall total */}
              <div className='d-flex justify-content-between align-items-center border-top pt-2'>
                <div className='mt-3 text-end fw-bold fs-5' style={{color: '#198754'}}>
                  Net Amount: ₹{selectedTests.reduce((sum, t) => sum + (t.testCost || 0), 0)}
                </div>

                <button
                  className='ePulse-btn-primary'
                  onClick={() =>
                    consumerApptData?.isConsumerAppt ? setStep(3) : setShowTimeSlotModal(true)
                  }
                  disabled={selectedTests.length === 0}
                >
                  Continue
                </button>
              </div>
            </div>
          )}
          {showTimeSlotModal && (
            <TimeSlotModal
              product={product}
              closeModal={closeModal}
              patientInfo={patientInfo}
              onContinue={({
                appointmentStartTime,
                appointmentEndTime,
                labRoomName,
                labRoomId,
                holdTimeSlot,
              }: {
                appointmentStartTime: string
                appointmentEndTime: string
                labRoomName: string
                labRoomId: string
                holdTimeSlot: string
              }) => {
                setDateTime({
                  appointmentStartTime,
                  appointmentEndTime,
                  labRoomName,
                  labRoomId,
                  holdTimeSlot
                })
                setShowTimeSlotModal(false)
                setStep(3)
              }}
            />
          )}
        </>
      )}
      {step === 3 && (
        <ConfirmAppointment
          id={consumerApptData?.isConsumerAppt ? consumerApptData.appointmentId : undefined}
          patientInfo={patientInfo}
          appointmentType={product}
          NetAmount={selectedTests.reduce((sum, t) => sum + (t.testCost || 0), 0)}
          testDetails={selectedTests}
          product={product}
          dateTime={dateTime}
          isConsumerAppointment={consumerApptData?.isConsumerAppt}
          againSeledtSlot={againSeledtSlot}
          onAppointmentSuccess={(url) => {
            setPdfUrl(url)
            setShowDownloadModal(true)
          }}
        />
      )}
      {showDownloadModal && (
        <DownloadPdfModal pdfUrl={pdfUrl} onClose={() => setShowDownloadModal(false)} />
      )}
    </div>
  )
}

export default CreateAppointment
